export const getFileUrlPrefix='https://cors-anywhere.herokuapp.com'
